import _ from 'lodash'
import { ActionContext } from 'vuex'
import { IState } from '@/store/service/state'
import { commonState } from '../service/state'
import { commonMutations } from '../service/mutations'
import { commonGetters } from '../service/getters'
import { findAll, findByPk, createItem, updateItem, deleteItem, addNewItem, changeDeletionMark, resetState } from '../service/actions'
import Vue from 'vue'

import BasicObject from '@/dto/AppObject.json'
const apiUrl = 'app_objects'

export const state = Object.assign({}, _.cloneDeep(commonState))

export const mutations = {
  ...commonMutations,

  addObjectField(state: IState, payload: any) {
    payload.fields.splice(payload.index, 0, payload.field)
  },

  moveObjectField(state: IState, payload: any) {
    if (payload.toIndex < 0 || payload.toIndex > payload.fields.length - 1) {
      return
    }

    const fieldFrom = payload.fields.splice(payload.fromIndex, 1)
    payload.fields.splice(payload.toIndex, 0, fieldFrom[0])
  },

  deleteObjectField(state: IState, payload: any) {
    payload.fields.splice(payload.index, 1)
  },

  setObjectField(state: IState, payload: any) {
    Vue.set(payload.fields, payload.index, payload.field)
  },
}

export const actions = {
  async findAll(context: ActionContext<IState, any>, payload: any) {
    return findAll(context, apiUrl, payload)
  },

  async findByPk(context: ActionContext<IState, any>, payload: any) {
    return findByPk(context, apiUrl, payload)
  },

  async create(context: ActionContext<IState, any>, payload: any) {
    return createItem(context, apiUrl, payload)
  },

  async update(context: ActionContext<IState, any>, payload: any) {
    return updateItem(context, apiUrl, payload)
  },

  async delete(context: ActionContext<IState, any>, payload: any) {
    return deleteItem(context, apiUrl, payload)
  },

  async changeDeletionMark(context: ActionContext<IState, any>, payload: any) {
    return changeDeletionMark(context, apiUrl, payload)
  },

  async addNew(context: ActionContext<IState, any>, payload: any) {
    return addNewItem(context, { basicObject: BasicObject }, payload)
  },

  async getSelectFields() {
    return [{ key: 'name', label: 'table.name', sortable: true }]
  },

  resetState(context: ActionContext<IState, any>) {
    resetState(context)
  },
}

export const getters = { ...commonGetters }
